import { DOCS_FORM_NAMES } from "core/consts";
import { ControlledTextarea } from "ds/ui";
import { FormFieldConfig } from "../..";
import { MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS } from "../Cardiology/sections";

export const DischargeLetterAccidentSurgeryFormSections: FormFieldConfig<
  typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_TRAUMA_SURGERY
>["sections"] = [
  {
    fields: {
      additional_diagnostic_findings: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formFieldNames
                .additionalDiagnosticFindings
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="additional_diagnostic_findings"
          />
        ),
        position: 9,
      },
      allergies: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formFieldNames.allergies
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="allergies"
          />
        ),
        position: 5,
      },
      anamnesis: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formFieldNames.anamnesis
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="anamnesis"
          />
        ),
        position: 3,
      },
      appointments: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formFieldNames
                .appointments
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="appointments"
          />
        ),
        position: 12,
      },
      clinical_course: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formFieldNames
                .clinicalCourse
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="clinical_course"
          />
        ),
        position: 10,
      },
      diagnoses: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formFieldNames.diagnoses
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="diagnoses"
          />
        ),
        position: 1,
      },
      discharge_medications: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formFieldNames
                .dischargeMedications
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="discharge_medications"
          />
        ),
        position: 14,
      },
      ecg: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={translations.extractDocs.dischargeLetter.formFieldNames.ecg}
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="ecg"
          />
        ),
        position: 8,
      },
      lab_results: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formFieldNames.labResults
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="lab_results"
          />
        ),
        position: 7,
      },
      parameters: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formFieldNames.parameters
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="parameters"
          />
        ),
        position: 13,
      },
      physical_status: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formFieldNames
                .physicalStatus
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="physical_status"
          />
        ),
        position: 6,
      },
      recommendations: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formFieldNames
                .recommendations
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="discharge_recommendations"
          />
        ),
        position: 11,
      },
      social_anamnesis: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formFieldNames
                .socialAnamnesis
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="social_anamnesis"
          />
        ),
        position: 4,
      },
      therapy: {
        input: ({ translations }) => (
          <ControlledTextarea
            label={
              translations.extractDocs.dischargeLetter.formFieldNames.therapy
            }
            maxRows={MAX_DISCHARGE_LETTER_TEXT_AREA_ROWS}
            name="therapy"
          />
        ),
        position: 2,
      },
    },
    position: 1,
    title: ({ translations }) =>
      translations.extractDocs.dischargeLetter.formTraumSurgery.sectionTitle,
  },
];
